/**
 * guobgf 2021-03-14
 * 友空间 ucg方法
 */
import nativeFuns from "../../../../mobile/utils/jsbridge/ykjbridge";
import {UCG_COMM_URL, UCG_FORM_COMM_URL, UCG_UPLOAD_URL} from "../../../constant";
import {GetQuery, langCheck} from "../../../../mobile/utils/utils";
import {getAppReqParam} from "../../../../mobile/utils/AppUrlUtils";
import ajax from "../../../core/ajax";
import {getMtlDeviceId, getMtlToken} from "../../../core/busData";
import {Toast} from "antd-mobile";

const showLoading = () => {
    Toast.loading(langCheck('hrzzmb-000001', false, null, "hrzzmb"), 0)
};

const hideLoading = () => {
    Toast.hide()
};

function adaptUrl(url) {
    url = url.replace('/nccloud/resources', '/ncc_mobile');
    return url;
}

function adaptUrl(url, isWap) {
    if (isWap) {
        url = url.replace('/ncchr', '/ncc_mobile_vue');
    } else {
        url = url.replace('/nccloud/resources', '/ncc_mobile');
    }
    return url;
}

function callAction(
    {
        data = {},
        url,
        headers,
        info = {},
        async = true,
        success = function (res) {
            console.log(res);
        },
        error = function (res) {
            console.error(res);
        },
        ...other
    }) {
    if (!async) {
        syncAjax({
            data,
            url,
            headers,
            info,
            async,
            success,
            error,
            ...other
        })
    } else if (headers && headers['Content-Type'] === 'multipart/form-data') {
        formAjax({
            data,
            url,
            headers,
            info,
            async,
            success,
            error,
            ...other
        })
    } else {
        if (!url.includes('/mob/') &&
            /*url !== '/nccloud/hr/login/HRLoginVerfiyAction.do' &&*/
            !url.includes('hryf') &&
            url !== '/nccloud/hrhi/widget/PsndocWidgetAction.do') {
            url = url.replace('/nccloud/', '/nccloud/mob/');
            url = url.substring(0, url.length - 3);
        }
        let strData = typeof data === 'string' ? data : JSON.stringify(data);
        let newData = {
            busiParamJson: strData
        };
        let {appcode} = getAppReqParam();
        if (!appcode) {
            let {c} = GetQuery(window.location.href);
            appcode = info.appcode ? info.appcode : c;
        }
        if (appcode) {
            newData.sysParamJson = {
                appCode: appcode,
                appcode
            }
        }

        if (url === '/nccloud/mob/platform/attachment/query') {
            url = '/nccloud/mob/hrpub/pub/MobImgAction'
        }
        mtl.ncc.callAction(
            {
                isCommon: true,
                router: UCG_COMM_URL,
                params: newData,
                url,
                headers,
                info,
                success,
                error,
                ...other,
            }
        )
    }
}

function formAjax({
                      data = {},
                      url,
                      headers,
                      info = {},
                      async = true,
                      success = function (res) {
                          console.log(res);
                      },
                      error = function (res) {
                          console.error(res);
                      },
                      ...other
                  }) {

    if (!url.includes('/mob/') &&
        /*url !== '/nccloud/hr/login/HRLoginVerfiyAction.do' &&*/
        !url.includes('hryf') &&
        url !== '/nccloud/hrhi/widget/PsndocWidgetAction.do') {
        url = url.replace('/nccloud/', '/nccloud/mob/');
        url = url.substring(0, url.length - 3);
    }
    let {appcode, pagecode} = getAppReqParam();
    if (!appcode) {
        let {c} = GetQuery(window.location.href);
        appcode = info.appcode ? info.appcode : c ? c : "10228888";
    }
    if (!pagecode) {
        let {p} = GetQuery(window.location.href);
        pagecode = info.pageCode || p
    }
    let sysParamJson = {}, newData, contentType = "application/json";
    if (other.sysParameter) {
        sysParamJson = other.sysParameter;
    } else {
        sysParamJson = {
            appcode,
            appCode: appcode,
            pageCode: pagecode,
            ts: new Date().getTime(),
            from: ''
        };
    }
    contentType = 'multipart/form-data';
    newData = data;
    for (let key in sysParamJson) {
        newData.append(key, sysParamJson[key]);
    }
    let token = getMtlToken();
    let deviceId = getMtlDeviceId();
    if (url === '/nccloud/mob/platform/attachment/query') {
        url = '/nccloud/mob/hrpub/pub/MobImgAction'
    }
    newData.append('url', url);
    ajax({
        url: UCG_FORM_COMM_URL,
        async: async,
        data: newData,
        headers: {
            "terminalType": 'UPESN',
            "deviceId": deviceId,
            "token": token,
            "Content-Type": contentType
        },
        success: (res) => {
            success(res);
        },
        error: (err) => {
            error(err)
        }
    })
}

function syncAjax({
                      data = {},
                      url,
                      headers,
                      info = {},
                      async = true,
                      success = function (res) {
                          console.log(res);
                      },
                      error = function (res) {
                          console.error(res);
                      },
                      ...other
                  }) {

    if (!url.includes('/mob/') &&
        /*url !== '/nccloud/hr/login/HRLoginVerfiyAction.do' &&*/
        !url.includes('hryf') &&
        url !== '/nccloud/hrhi/widget/PsndocWidgetAction.do') {
        url = url.replace('/nccloud/', '/nccloud/mob/');
        url = url.substring(0, url.length - 3);
    }
    let {appcode, pagecode} = getAppReqParam();
    if (!appcode) {
        let {c} = GetQuery(window.location.href);
        appcode = info.appcode ? info.appcode : c ? c : "10228888";
    }
    if (!pagecode) {
        let {p} = GetQuery(window.location.href);
        pagecode = info.pageCode || p
    }
    let sysParamJson = {}, newData, contentType = "application/json";
    if (other.sysParameter) {
        sysParamJson = other.sysParameter;
    } else {
        sysParamJson = {
            appcode,
            appCode: appcode,
            pageCode: pagecode,
            ts: new Date().getTime(),
            from: ''
        };
    }
    let strData = typeof data === 'string' ? data : JSON.stringify(data);
    newData = {
        busiParamJson: strData,
        sysParamJson
    };
    let token = getMtlToken();
    let deviceId = getMtlDeviceId();
    if (url === '/nccloud/mob/platform/attachment/query') {
        url = '/nccloud/mob/hrpub/pub/MobImgAction'
    }
    ajax({
        url: UCG_COMM_URL,
        async: async,
        data: {
            url: url,
            header: headers,
            body: newData,
            method: other.method || 'POST',
            "Content-Type": contentType
        },
        headers: {
            "terminalType": 'UPESN',
            "deviceId": deviceId,
            "token": token,
            "Content-Type": contentType
        },
        success: (res) => {
            success(res);
        },
        error: (err) => {
            error(err)
        }
    })
}

function upload(
    {
        body = {},
        info = {},
        success,
        error
    }) {
    let newData;
    let {c} = GetQuery(window.location.href);
    let code = info.appcode ? info.appcode : c ? c : "10228888";
    let sysParamData = {
        sys_busiaction: `${code || null}-${window.actionName || null}`,
        sys_appcode: code,
        sys_ts: new Date().getTime()
    };

    newData = new FormData();
    let it = body.entries();
    let flag = false, busiParamJson = {};
    while (!flag) {
        let {done, value} = it.next();
        flag = done;
        if (value) {
            let [formKey, formData] = value;
            if (formKey !== 'file') {
                busiParamJson[formKey] = formData;
            } else {
                newData.append(formKey, formData)
            }
        }
    }
    newData.append('busiParamJson', JSON.stringify(busiParamJson));
    newData.append('sysParamData', JSON.stringify(sysParamData));

    let file = newData.get('file');
    let isImage = file && file.type.indexOf('image') > -1;
    let tempSrc = '';
    if (isImage) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            tempSrc = e.target.result;
        };
    }
    let token = getMtlToken();
    let deviceId = getMtlDeviceId();
    let headers = {
        "terminalType": 'UPESN',
        "deviceId": deviceId,
        "token": token,
        "Content-Type": 'multipart/form-data'
    };
    showLoading();
    return new Promise((resolve, reject) => {
        const errFun = (err) => {
            hideLoading();
            console.log(err);
            if (error) {
                error(err);
                return;
            }
            let errMsg = err && err.message;
            reject({
                ...err.data,
                data: {
                    error: {
                        message: errMsg
                    }
                },
                success: false
            });
        }
        ajax({
            url: UCG_UPLOAD_URL,
            data: newData,
            headers: headers,
            success: (res) => {
                if (res.code === '200' || res.code === '1000000000') {
                    hideLoading();
                    res.success = true;
                    res.code = '200';
                    try {
                        if (isImage) res.data[0].previewUrl = tempSrc;
                    } catch (e) {

                    }
                    if (success) {
                        success(res);
                        return;
                    }
                    resolve(res);
                } else {
                    errFun(res)
                }
            },
            error: (err) => errFun(err)
        })
    })
}

let acts = [
    {
        api: 'adaptUrl',
        fn: adaptUrl
    },
    {
        api: 'callAction',
        fn: callAction
    },
    {
        api: 'upload',
        fn: upload
    }
]

//添加mtl方法
Object.keys(mtl.ncc).forEach(key => {
    if (key === 'callAction') return;
    acts.push({
        api: key,
        fn: mtl.ncc[key]
    })
})
//添加友空间native方法
for (const key in nativeFuns) {
    acts.push({
        api: key,
        fn: nativeFuns[key]
    })
}

export default acts;